import { render, staticRenderFns } from "./TotalGeneralBudget.vue?vue&type=template&id=03142713&"
import script from "./TotalGeneralBudget.vue?vue&type=script&lang=js&"
export * from "./TotalGeneralBudget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03142713')) {
      api.createRecord('03142713', component.options)
    } else {
      api.reload('03142713', component.options)
    }
    module.hot.accept("./TotalGeneralBudget.vue?vue&type=template&id=03142713&", function () {
      api.rerender('03142713', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Budget/TotalGeneralBudget.vue"
export default component.exports